import {
    NEW_TAXES,
    NEW_PRODUCT,
    NEW_TABLE_PRODUCTS
} from '../actions/productsActions';

import {
    RESET_ACCOUNT,
    LOG_OUT

} from '../actions/accountActions';

const initialState = {
    taxes: [],
    product: null,
    tableProducts: [],
    addendaProducts: [],
    emptyAddenda: []

} // END initialState


export default function (state = initialState, action) {
    let { payload } = action, newState;
    switch (action.type) {
        case NEW_TAXES:
            newState = { taxes: payload };
            return { ...state, ...newState };
        case NEW_PRODUCT:
            newState = { product: payload };
            return { ...state, ...newState };
        case NEW_TABLE_PRODUCTS:
            newState = { tableProducts: payload.tableProducts, addendaProducts: payload.addendaProducts, emptyAddenda: payload.emptyAddenda };
            return { ...state, ...newState };

        case RESET_ACCOUNT:
        case LOG_OUT:
            newState = { initialState }
            return { ...state, ...initialState };

        default:
            return state;

    } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/productsReducer.js